import { getEnumValues } from '../enums';
export enum AclPermission{
	Owner='owner',
	Read='read',
	Write='write',
	Delete='delete',
}
export const AclPermissionValues = getEnumValues<AclPermission>(AclPermission);